<template>
  <v-defaults-provider :defaults="defaultData">
    <v-btn
      v-element-hover="onHover"
      v-bind="$attrs"
      class="u-btn"
      @click="emit('click', $event)"
    >
      <template
        v-for="(slot, index) of Object.keys($slots)"
        :key="index"
        #[slot]="scope"
      >
        <slot
          :name="slot"
          v-bind="scope || {}"
        />
      </template>
    </v-btn>
  </v-defaults-provider>
</template>

<script setup lang="ts">
import { vElementHover } from '@vueuse/components'

defineOptions({
  inheritAttrs: false,
})

const emit = defineEmits(['click'])

const {
  inverted,
  size,
  variant,
  ...definedProps
} = defineProps({
  ...useBtnProps(),
})
const props = useDefaults(definedProps, 'UBtn')
const options = computed(() => ({
  inverted,
  size,
  variant,
}))

const {
  onHover,
  defaultData,
} = useBtn(options, props)
</script>
